// load scss
import './Main.scss';
// load svg sprite
import loadSpriteSvgs from './Component/Icon';
loadSpriteSvgs();

import './Component/Button';

// correct underline positioning for current nav element
const mouseoverEvent = new Event('mouseover');
const currentNavEl = document.querySelector('.nav__list-element--level-1.current');
setTimeout(() => {
    if (currentNavEl) {
        currentNavEl.dispatchEvent(mouseoverEvent);
    }
}, 0);
